import { useEffect, useId, useRef, useState, type ReactNode } from 'react';

export function MobileNavigation({
  title,
  children,
  inline = false,
}: {
  title: string;
  children: ReactNode;
  inline?: boolean;
}) {
  const menuId = useId();
  const touch = useRef<number | undefined>(undefined);
  const opener = useRef<HTMLButtonElement>(null);
  const [narrow, setNarrow] = useState(() => window.matchMedia?.('(max-width: 900px)').matches ?? false);
  const [open, setOpen] = useState(false);
  const drawer = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const media = window.matchMedia?.('(max-width: 900px)');
    if (!media) return;
    const change = () => {
      setNarrow(media.matches);
      setOpen(false);
    };
    media.addEventListener('change', change);
    return () => media.removeEventListener('change', change);
  }, []);
  useEffect(() => {
    setOpen(false);
  }, [title]);
  useEffect(() => {
    if (open) {
      drawer.current?.showModal();
      const previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = previousOverflow;
        opener.current?.focus();
      };
    } else drawer.current?.close();
  }, [open]);
  if (!narrow) return inline ? <>{children}</> : null;
  return (
    <>
      <header className={`mobile-header${inline ? ' server-menu-header' : ''}`}>
        <button
          className="btn ghost"
          ref={opener}
          aria-label={inline ? `${title}を開く` : 'メニューを開く'}
          aria-expanded={open}
          aria-controls={menuId}
          onClick={() => setOpen(true)}
        >
          <span aria-hidden="true">☰</span>
        </button>
        <span className="mobile-title">{title}</span>
      </header>
      <dialog
        id={menuId}
        className="mobile-drawer sidebar"
        aria-label={inline ? title : 'メインメニュー'}
        aria-modal="true"
        onCancel={(event) => {
          event.preventDefault();
          setOpen(false);
        }}
        onTouchStart={(event) => {
          touch.current = event.touches[0]?.clientX;
        }}
        onTouchEnd={(event) => {
          const end = event.changedTouches[0]?.clientX;
          if (touch.current !== undefined && end !== undefined && touch.current - end > 50) setOpen(false);
          touch.current = undefined;
        }}
        ref={drawer}
        onClose={() => setOpen(false)}
        onClick={(event) => {
          if (event.target === event.currentTarget) setOpen(false);
        }}
      >
        <div className="drawer-content">
          <button className="btn ghost drawer-close" onClick={() => setOpen(false)} autoFocus>
            メニューを閉じる
          </button>
          <div
            className="stack"
            onClick={(event) => {
              if ((event.target as Element).closest('a, button')) setOpen(false);
            }}
          >
            {children}
          </div>
        </div>
      </dialog>
    </>
  );
}
